import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import CellularDataOnOffData from "../../../Models/Content/CellularDataOnOffData";
import CellularDataOnOff
  from "app/Components/Block/CellularDataOnOff/CellularDataOnOff";

export default class CellularDataOnOffBlock extends EpiComponent<CellularDataOnOffData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CellularDataOnOff context={this.getContext()} contentData={this.props.data} />;
  }
}
